const HEADINGS_SEPARATOR = "!!";

export default HEADINGS_SEPARATOR;
